import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';
import {BookAvailabilityDto} from './book-availability-dto';
import {BaseUserService} from '../../../../auth/account/base-user.service';

@Injectable({
  providedIn: 'root'
})
export class AlephService extends BaseUserService{

  constructor(private http: HttpClient) {
  super();
  }

  getAvailability(matIds: string[] , externalURL?: string) {
    return this.http.post<BookAvailabilityDto>('alephUrl/omnis/book-availability',
      {apiType : 'PRIMO', params:{ mmsIds: matIds} , url: externalURL });
  }

}
